import {
  StyleDocumentItems,
  StyleDocumentItem,
  styleDocumentUploadWrapper,
} from '../style'
import Column from '@components/column'
import { Fragment } from 'react'
import Fields from '@components/fields'
import Empty from '@commons/empty'
import Button from '@components/button'
import Svg from '@components/svg'
const Registrations = ({ registrations, disabled, setFieldValue }) => {
  return (
    <>
      {!disabled && (
        <Column alignItems="flex-end">
          <Button
            title="Add Document"
            height={45}
            leftComponent={<Svg svg="plus" color={'white'} />}
            onClick={() => {
              setFieldValue('registrations', [
                ...(registrations || []),
                {
                  name: '',
                  image: '',
                },
              ])
            }}
          />
        </Column>
      )}
      {!!registrations?.length ? (
        <StyleDocumentItems>
          {registrations?.map((_, index: number) => {
            return (
              <Fragment key={index}>
                <StyleDocumentItem>
                  <Fields.Upload
                    varient="drag"
                    name={`registrations[${index}][image]`}
                    placeholder="Upload Document Here"
                    styleWrapper={styleDocumentUploadWrapper}
                    size={180}
                    icon={'circleGallery'}
                    disabled={disabled}
                  />
                  <Column rowGap={20} styleColumn="margin-top:20px;">
                    <Fields.Input
                      name={`registrations[${index}][name]`}
                      placeholder="Document Name"
                      label="Document Name"
                      disabled={disabled}
                    />
                  </Column>
                </StyleDocumentItem>
              </Fragment>
            )
          })}
        </StyleDocumentItems>
      ) : (
        <Empty />
      )}
    </>
  )
}

export default Registrations
